import Skeleton from "react-loading-skeleton"
import FloatTitleCard from "../cards/floatTitleCard"

const MyProfileSkt = () => {
    return (
        <section className="py-3 w-100 d-flex flex-column gap-4">

            <FloatTitleCard title="مشخصات کاربر">

                <div className="d-flex align-items-center justify-content-between iran-sans">

                    <div className="d-flex align-items-center justify-content-between gap-3">

                        <Skeleton className="tw-size-16 tw-rounded-full" />

                        <div className="d-flex flex-column gap-2">
                            <Skeleton className="tw-w-20 tw-p-1" />
                            <Skeleton className="tw-w-16 tw-p-1" />
                        </div>

                    </div>

                    <button className="d-flex m-0 p-0 align-items-center justify-cotent-center tw-size-6 tw-border-none tw-bg-inherit">
                        <Skeleton className="tw-absolute tw-left-6 tw-top-1/3 tw-size-10 tw-rounded-lg" />
                    </button>

                </div>

            </FloatTitleCard>

            <FloatTitleCard title="نوبت های من ">

                <div className="d-flex flex-column align-items-center justify-content-center iran-sans gap-4">

                    <div className="d-flex flex-column gap-4 gap-sm-0 flex-sm-row align-items-center w-100 justify-content-evenly">

                        <div className="tw-flex tw-flex-col tw-justify-center tw-items-center">
                            <Skeleton className="tw-p-1 tw-w-12 tw-h-10" />
                            <Skeleton className="tw-w-28" />
                        </div>
                        <div className="tw-flex tw-flex-col tw-justify-center tw-items-center">
                            <Skeleton className="tw-p-1 tw-w-12 tw-h-10" />
                            <Skeleton className="tw-w-28" />
                        </div>
                        <div className="tw-flex tw-flex-col tw-justify-center tw-items-center">
                            <Skeleton className="tw-p-1 tw-w-12 tw-h-10" />
                            <Skeleton className="tw-w-28" />
                        </div>

                    </div>

                    <div className="d-flex m-0 p-0 align-items-center gap-2 justify-cotent-center tw-cursor-pointer">
                        <Skeleton className="tw-w-32 tw-p-2" />
                    </div>

                </div>

            </FloatTitleCard>

            <FloatTitleCard title="اعلانات">

                <div className="tw-grid md:tw-grid-cols-2 tw-gap-3">

                    {
                        Array(4).fill(0).map((_, index) =>
                            <div key={index} className="d-flex flex-column gap-2 w-100 border flex-shrink-0 flex-grow-1 w-25 border-bootstrap-gray-300 rounded p-2 background-bootstrap-gray-100">
                                <Skeleton className="m-0 fs-14 fw-regular color-bootstrap-gray-600" />
                                <Skeleton className="tw-w-full tw-h-3" />
                                <Skeleton className="tw-w-full tw-h-3" />
                            </div>
                        )
                    }

                </div>

            </FloatTitleCard>

        </section>
    )
}

export default MyProfileSkt